import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';
import {
  defaultState as paginationDefaultState,
  PaginationContextState,
} from 'utils/contexts/pagination';
import { SortingContextState, defaultState as sortingDefaultState } from 'utils/contexts/sorting';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { usePrioritizeUserFields } from '../hooks';

// Context for tracking values relevant for the user table part of the page
type UsersTableState = {
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  sortBy: string;
} & PaginationContextState &
  SortingContextState;

export const defaultUsersTableState = {
  ...paginationDefaultState,
  ...sortingDefaultState,
};

export const UsersTableContext = createContext<UsersTableState>(defaultUsersTableState);

export const useUsersTableContext = () => useContext(UsersTableContext);

export const UsersTableContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const prioritizedFields = usePrioritizeUserFields([]);

  // Sorting
  const [sortBy, setSortBy] = useState(prioritizedFields[0]?.field);
  const [sortDirection, setSortDirection] = useState<SORT_DIRECTIONS>(SORT_DIRECTIONS.DESCENDING);

  const value = {
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
  };

  return <UsersTableContext.Provider value={value}>{children}</UsersTableContext.Provider>;
};
